import React, { useCallback, useEffect, useState } from 'react';
import PolicyChange from '../PolicyChange';
import VehicleSelect from './VehicleSelect';
import { Form } from 'semantic-ui-react';
import VehicleDisplay from './VehicleDisplay';
import Conclusion from '../Conclusion';
import ChangedFields from '../ChangedFields';

const DeleteVehicle = ({ actions, policy, effectiveDate, onCancel, onComplete, save, onError, setLoading, onSave, onExit, rate, setRate }) => {
	const [vehicle, setVehicle] = useState(null);
	const [isComplete, setIsComplete] = useState(false);

	useEffect(() => {
		if (save && save.originalVehicle) {
			setVehicle(save.originalVehicle);
		}
	}, [save]);

	const _onSaveAndExit = useCallback(async () => {
		await onSave({ originalVehicle: vehicle }, rate);
		onExit();
	}, [onExit, onSave, rate, vehicle]);

	const onRate = useCallback(
		async (selectedVehicle) => {
			try {
				setVehicle(selectedVehicle);
				setLoading('Generating rate');
				var result = await actions.rateDeleteVehicle({ policyId: policy.policyId, policyImageNum: policy.policyImageNum, policyNumber: policy.policyNumber, effectiveDate, vehicleNum: selectedVehicle.vehicleNum });

				const _rate = { ...result.response, email: { action: 'Removed', vehicle: selectedVehicle } };

				setRate(_rate);
				await onSave({ originalVehicle: selectedVehicle }, _rate);

				setLoading(null);
			} catch (error) {
				setVehicle(null);
				setLoading(null);
				onError(error.error);
			}
		},
		[actions, effectiveDate, onError, onSave, policy, setLoading, setRate]
	);

	const onRateConfirm = useCallback(() => {
		onComplete(rate);
		setIsComplete(true);
	}, [onComplete, rate]);

	if (!vehicle) {
		return <VehicleSelect onVehicleSelect={onRate} policy={policy} confirmMessage='Are you sure you want to delete this vehicle?' onCancel={onCancel} message='Please select the vehicle you would like to delete' effectiveDate={effectiveDate} />;
	}
	if (!isComplete) {
		return (
			<PolicyChange policy={policy} name='Vehicle' title='Please review and complete deleting a vehicle' onSaveAndExit={_onSaveAndExit} onComplete={onRateConfirm} rate={rate} onCancel={onCancel}>
				<Form>
					<Form.Display inline label='Deleted Vehicle' value={<VehicleDisplay vehicle={vehicle} showVin />} />
				</Form>
			</PolicyChange>
		);
	} else {
		return (
			<Conclusion title='The deletion of the following vehicle was completed successfully!' rate={rate} policy={policy} onExit={onExit}>
				<ChangedFields other={[{ label: 'Deleted Vehicle', text: <VehicleDisplay vehicle={vehicle} showVin /> }]} />
			</Conclusion>
		);
	}
};

DeleteVehicle.propTypes = {};

export default DeleteVehicle;
